import { render, staticRenderFns } from "./NoputInStorageShop.vue?vue&type=template&id=5e2b52ce&scoped=true"
import script from "./NoputInStorageShop.vue?vue&type=script&lang=ts"
export * from "./NoputInStorageShop.vue?vue&type=script&lang=ts"
import style0 from "./NoputInStorageShop.vue?vue&type=style&index=0&id=5e2b52ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b52ce",
  null
  
)

export default component.exports